import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-queue-header',
  templateUrl: './queue-header.component.html',
  styleUrls: ['./queue-header.component.scss']
})
export class QueueHeaderComponent{
  @Input() clientLogoUrl: string;
  @Input() branchName: string;
  @Input() menuLink: string;
  @Input() instagramLink: string;
  @Input() facebookLink: string;
  @Input() websiteLink: string;

}
